import React from 'react';
import WholeMeProfileBadges from 'pages/wholeme/molecules/wholeMeProfileBadges/WholeMeProfileBadges';
import WholeMeProfileQuotation from 'pages/wholeme/molecules/wholeMeProfileQuotation/WholeMeProfileQuotation';
import WholeMeProfileHealth from 'pages/wholeme/molecules/wholeMeProfileHealth/WholeMeProfileHealth';
import WholeMeProfileInterests from 'pages/wholeme/molecules/wholeMeProfileInterests/WholeMeProfileInterests';
import WholeMeProfileRelationships from 'pages/wholeme/molecules/wholeMeProfileRelationships/WholeMeProfileRelationships';
import WholeMeProfileFinances from 'pages/wholeme/molecules/wholeMeProfileFinances/WholeMeProfileFinances';
import WholeMeProfileLegacyProfile from 'pages/wholeme/molecules/wholeMeProfileLegacyProfile/WholeMeProfileLegacyProfile';
import WholeMeProfilePurposeVideo from 'pages/wholeme/molecules/wholeMeProfilePurposeVideo/WholeMeProfilePurposeVideo';
import WholeMeProfileLinkedIn from 'pages/wholeme/molecules/wholeMeProfileLinkedIn/WholeMeProfileLinkedIn';
import WholeMeProfileGoals from 'pages/wholeme/molecules/wholeMeProfileGoals/WholeMeProfileGoals';
import WholeMeProfileEducation from 'pages/wholeme/molecules/wholeMeProfileEducationCareer/WholeMeProfileEducation';
import WholeMeProfileCareerAspirations from 'pages/wholeme/molecules/wholeMeProfileEducationCareer/WholeMeProfileCareerAspirations';

import {
  Stack,
} from '@mui/material';

const WholeMeProfilePrivate = ({
  profile, wholeMeClient, editable, onEdit, isViewingAdmin, legacyProfileData,
}) => (
  <Stack spacing={1.5}>
    {profile && (
      <>
        <WholeMeProfilePurposeVideo profile={profile} editable={editable} wholeMeClient={wholeMeClient} />
        <WholeMeProfileBadges
          profile={profile}
          wholeMeClient={wholeMeClient}
        />
        {(editable || isViewingAdmin) && (
          <WholeMeProfileQuotation profile={profile} onEdit={onEdit} />
        )}
        {editable && (
          <WholeMeProfileLegacyProfile
            legacyProfileData={legacyProfileData}
            profile={profile}
            onEdit={onEdit}
            isViewOnly={!editable}
          />
        )}
        <WholeMeProfileLinkedIn profile={profile} isViewOnly />
        {editable && <WholeMeProfileGoals editable={editable} profile={profile} />}
        <WholeMeProfileEducation profile={profile} onEdit={onEdit} isViewOnly={!editable} />
        <WholeMeProfileCareerAspirations profile={profile} onEdit={onEdit} isViewOnly={!editable} />
        <WholeMeProfileHealth profile={profile} onEdit={onEdit} isViewOnly={!editable} />
        <WholeMeProfileInterests profile={profile} onEdit={onEdit} isViewOnly={!editable} />
        <WholeMeProfileRelationships profile={profile} onEdit={onEdit} isViewOnly={!editable} />
        <WholeMeProfileFinances profile={profile} onEdit={onEdit} isViewOnly={!editable} />
      </>
    )}
  </Stack>
);

export default WholeMeProfilePrivate;
